import { DefaultsInstance } from 'vuetify';
const customizationClassIndicator = 'op-mod';

const controlDefaults: DefaultsInstance = {
  VCard: {
    elevation: 0,
    color: 'transparent',
    class: `${customizationClassIndicator} bg-transparent`,
  },
};

export default controlDefaults;
